import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createSlots as _createSlots, normalizeClass as _normalizeClass } from "vue"

import debounce from 'debounce';
import { PropType, ref, toRefs } from 'vue';

import { formatControl, isValidDate } from '@/helpers/formatter';
import { Criterion } from '@/Litigation/criterion.entity';


export default /*#__PURE__*/_defineComponent({
  __name: 'EntryControl',
  props: {
    criterion: {
        type: Object as PropType<Criterion>,
        required: true,
    },
    occurrence: {
        type: Number,
        required: true,
    },
    initialValue: {
        type: Array<String>,
        required: true,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
},
  emits: ['change'],
  setup(__props, { expose: __expose, emit }) {

const props = __props;



const { criterion, occurrence, initialValue } = toRefs(props);
const entryRef = ref();
const control = ref();
const isDateInvalid = ref(false);


const isMultiple = (criterion: Criterion) => criterion.control === 'dropdown_multiple';

const fetchSuggestions = (queryString: string, cb: (suggestions: { value: string }[]) => void) => {
    const suggestions = criterion.value.suggestions ?? [];
    const filtered = queryString
        ? suggestions.filter((s) => s.toLowerCase().includes(queryString.toLowerCase()))
        : suggestions;
    cb(filtered.map((s) => ({ value: s })));
};

const onChange = () => {
    if (!isMultiple(criterion.value)) {
        control.value = formatControl(control.value, criterion.value.control);
    }

    if (criterion.value.control === 'date') {
        isDateInvalid.value = !isValidDate(control.value as string);

        if (isDateInvalid.value) {
            return;
        }
    }

    emit(
        'change',
        criterion.value,
        occurrence.value,
        Array.isArray(control.value) ? Object.values(control.value) : [control.value],
    );
};

const onChangeDebounced = debounce(onChange, 1000);

const setValue = (value: string) => {
    control.value = value;
    onChange();
};

__expose({ criterion, occurrence, control, setValue });

control.value = isMultiple(criterion.value) ? initialValue.value : initialValue.value[0];

if (criterion.value.control === 'date') {
    isDateInvalid.value = !isValidDate((control.value as string) ?? '');
}

return (_ctx: any,_cache: any) => {
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_autocomplete = _resolveComponent("el-autocomplete")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_unref(criterion).control == 'switch')
    ? (_openBlock(), _createBlock(_component_el_radio_group, {
        key: 0,
        ref_key: "entryRef",
        ref: entryRef,
        modelValue: control.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((control).value = $event)),
        size: "small",
        disabled: __props.disabled,
        placeholder: _unref(criterion).help,
        onChange: onChange
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_radio_button, { label: "1" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.yes')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_radio_button, { label: "0" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.no')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_radio_button, { label: "-1" }, {
            default: _withCtx(() => [
              _createTextVNode("-1")
            ]),
            _: 1
          }),
          _createVNode(_component_el_radio_button, { label: "" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.empty')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue", "disabled", "placeholder"]))
    : (['dropdown_single', 'dropdown_multiple'].includes(_unref(criterion).control))
      ? (_openBlock(), _createBlock(_component_el_select, {
          key: 1,
          ref_key: "entryRef",
          ref: entryRef,
          modelValue: control.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((control).value = $event)),
          size: "small",
          clearable: _unref(criterion).control === 'dropdown_single',
          filterable: "",
          "allow-create": "",
          disabled: __props.disabled,
          placeholder: _unref(criterion).help,
          multiple: isMultiple(_unref(criterion)),
          "collapse-tags": isMultiple(_unref(criterion)),
          "collapse-tags-tooltip": isMultiple(_unref(criterion)),
          onChange: onChange
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(criterion).choices, (label, value) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: value,
                label: value + ' : ' + label,
                value: value
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue", "clearable", "disabled", "placeholder", "multiple", "collapse-tags", "collapse-tags-tooltip"]))
      : (_unref(criterion).control === 'text' && _unref(criterion).suggestions?.length > 0)
        ? (_openBlock(), _createBlock(_component_el_autocomplete, {
            key: 2,
            ref_key: "entryRef",
            ref: entryRef,
            modelValue: control.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((control).value = $event)),
            size: "small",
            disabled: __props.disabled,
            placeholder: _unref(criterion).help,
            "fetch-suggestions": fetchSuggestions,
            "trigger-on-focus": true,
            onSelect: onChange,
            onInput: _unref(onChangeDebounced)
          }, _createSlots({ _: 2 }, [
            (_unref(criterion).unit)
              ? {
                  name: "append",
                  fn: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(criterion).unit), 1)
                  ]),
                  key: "0"
                }
              : undefined
          ]), 1032, ["modelValue", "disabled", "placeholder", "onInput"]))
        : (_unref(criterion).control === 'date')
          ? (_openBlock(), _createBlock(_component_el_input, {
              key: 3,
              ref_key: "entryRef",
              ref: entryRef,
              modelValue: control.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((control).value = $event)),
              size: "small",
              autocomplete: "off",
              class: _normalizeClass({ 'is-invalid-date': isDateInvalid.value }),
              disabled: __props.disabled,
              placeholder: _unref(criterion).help,
              onInput: _unref(onChangeDebounced)
            }, _createSlots({ _: 2 }, [
              (isDateInvalid.value)
                ? {
                    name: "append",
                    fn: _withCtx(() => [
                      _createVNode(_component_el_popover, {
                        placement: "top",
                        width: 250,
                        "show-after": 200
                      }, {
                        reference: _withCtx(() => [
                          _createVNode(_component_el_tag, {
                            round: "",
                            size: "small",
                            type: "danger",
                            effect: "dark"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("!")
                            ]),
                            _: 1
                          })
                        ]),
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('analysis.invalidDate')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    key: "0"
                  }
                : (_unref(criterion).unit)
                  ? {
                      name: "append",
                      fn: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(criterion).unit), 1)
                      ]),
                      key: "1"
                    }
                  : undefined
            ]), 1032, ["modelValue", "class", "disabled", "placeholder", "onInput"]))
          : (_openBlock(), _createBlock(_component_el_input, {
              key: 4,
              ref_key: "entryRef",
              ref: entryRef,
              modelValue: control.value,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((control).value = $event)),
              size: "small",
              autocomplete: "off",
              disabled: __props.disabled,
              min: _unref(criterion).min,
              max: _unref(criterion).max,
              placeholder: _unref(criterion).help,
              onInput: _unref(onChangeDebounced)
            }, _createSlots({ _: 2 }, [
              (_unref(criterion).unit)
                ? {
                    name: "append",
                    fn: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(criterion).unit), 1)
                    ]),
                    key: "0"
                  }
                : undefined
            ]), 1032, ["modelValue", "disabled", "min", "max", "placeholder", "onInput"]))
}
}

})